var Participants =
    (function () {
        return {
            min: null,
            max: null,
            latency: 1000, /* in ms */
            rules: {
                minRequired: true
            },

            remove: function (self) {
                $('.participants div').last().removeClass('hidden');
                var _row = $(self).closest('.row');
                var form = _row.closest('form');
                var nextAll = _row.nextAll();

                nextAll.each(function (k, v) {
                    let index = $(v).index() - 2;
                    
                    $(v).data('index', index)
                        .attr('data-index', index)
                        .find('input')
                            .each(function (j, l) {
                                var input = $(l);
                                console.log("newname: " + input.attr('name').replace(/\[[0-9]+\]/, '[' + index + ']'));
                                input.attr('name', input.attr('name').replace(/\[[0-9]+\]/, '[' + index + ']'));
                            });
                });

                _row.remove();

                setTimeout(function () {
                    var min_participant = $('[name=\'Participants[' + (Participants.min - 1) + '].Email\']');

                    if (Participants.rules.minRequired && (!min_participant || !min_participant.length)) {
                        form.find('.save-button').attr('disabled', true).prop('disabled', true);
                    } else {
                        form.trigger('validate');
                    }
                }, 10);
            }
        };
    })();

function lookupClose(memberLookupModalID) {
    $('#new_customer_memberno').val("");
    $('#new_customer_name').val("");
    $('#new_customer_email').val("");
    $('#new_customer_phone').val("");
    $('#new_customer_sendInvoice').prop("checked", false);
    resetSearch();
    $('.modalBoxContainer').addClass('hidden');
}

function focusInput(target) {
    if ($(target).val() !== "") {
        $(target).parent().siblings().children('input').attr('disabled', true);
    } else {
        $('.input').attr('disabled', false);
    }
}

function lookupQuery(target, event, memberLookupModalID) {
    var e = event.which || event.keyCode;

    e === 13 && lookupSearch(target, memberLookupModalID);
}

function toggleview(key) {
    if (key === "create") {
        $('#create-member').removeClass('hidden').addClass('active');
        $('.search-tab').removeClass('active');
        $('.create-tab').addClass('active');
        $('#lookup-member').addClass('hidden').removeClass('active');
        $('#new_customer_name').focus();
    } else {
        $('#create-member').addClass('hidden').removeClass('active');
        $('.search-tab').addClass('active');
        $('.create-tab').removeClass('active');
        $('#lookup-member').removeClass('hidden').addClass('active');
        $('#lookup-member-search-input').focus();
    }
}

function addNewCustoner(self) {
    var newData = {
        memberNumber: $('#new_customer_memberno').val(),
        fullName: $('#new_customer_name').val(),
        primaryEmail: $('#new_customer_email').val(),
        primaryMobile: $('#new_customer_phone').val(),
        sendInvoice: $('#new_customer_sendInvoice').prop("checked")
    };
    if (newData.fullName !== "" && (newData.primaryEmail + newData.primaryMobile) !== "") {
        addrow(newData);
        var li = $('#new_customer_memberno').closest('.modalBoxContainer');
        lookupClose(li.get(0));
    }
}

function updateCustomer(self) {
    var newData = {
        memberNumber: $('#update_new_customer_memberno').val(),
        fullName: $('#update_new_customer_name').val(),
        primaryEmail: $('#update_new_customer_email').val(),
        primaryMobile: $('#update_new_customer_phone').val()
    };

    if (newData.fullName !== "" && (newData.primaryEmail + newData.primaryMobile) !== "") {
        updateCurrentrow(newData);
        var li = $('#new_customer_memberno').closest('.modalBoxContainer');
        lookupClose(li.get(0));
    }
}

function targetToSearchBy() {
    if ($('#search_by_name').prop("checked")) {
        return 1;
    } else if ($('#search_by_email').prop("checked")) {
        return 2;
    } else if ($('#search_by_member_no').prop("checked")) {
        return 3;
    } else if ($('#search_by_phone').prop("checked")) {
        return 4;
    }
}

function lookupSearch(target, memberLookupModalID) {
    if (target === "") {
        target = $('#lookup-member-search-input').get(0);
    }

    var $result = $('#asd');
    var searchby = targetToSearchBy();
    var query = $(target).val();
    let lastName = $('#lookup-member-search-input-lastname').val();
    if (!searchby || query.length < 2) {
        return;
    }

    if (currentBusIsoCode.toUpperCase() === "SE" && searchby === 1) {
        if (query.length < 2 || lastName.length < 2) {
            $('#' + warningModalID).removeClass('hidden');
            return;
        }
    }

    var $table = $('#lookup-member-result-scroll');
    $('#my_customers_accord').empty().html("<div id=\"empty\" class=\"flex flex-center\" style=\"flex-grow:1; height:30px; font-style:italic;\">" + modal_no_results + "<div>");
    $('#other_players_accord').empty();
    $table.append('<div id="lookup-spinner-wrapper" class="lookup-spinner-wrapper">' +
        '<div class="lookup-spinner">' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '<div></div>' +
        '</div>' +
        '</div>');

    let firstAndLastName = [query, lastName];
    $.post('/Profile/Lookup', { value: query, searchBy: searchby, firstAndLastName: firstAndLastName }, function (data) {
        $('#my_customers_accord').empty();
        $('#lookup-spinner-wrapper').remove();
        $result.empty();

        if (data.error) {
            $('#my_customers_accord').empty().html('<div id=\"empty\" class=\"flex flex-center\" style=\"flex-grow:1; height:30px; font-style:italic;\">' + model_noMembersFound + '</div>');
            $('#other_players_accord').empty();
            $('#my_customers_accord_header').find('.accordion-header-text').text(modal_my_customers_accord_header + " (" + $('#my_customers_accord').children().length + " " + modal_results + ")");
            if ($('#my_customers_accord').children().length === 1 && $('#my_customers_accord').children().get(0).id === "empty") {
                $('#my_customers_accord_header').find('.accordion-header-text').text(modal_my_customers_accord_header + " (0 " + modal_results + ")");
            }
            $('#other_players_accord_header').find('.accordion-header-text').text(modal_ohter_players_accord_header + " (" + $('#other_players_accord').children().length + " " + modal_results + ")");
            return;
        }

        data.sort(function (x, y) {
            var a = $.trim(x.fullName).toLowerCase();
            var b = $.trim(y.fullName).toLowerCase();

            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        });
        $.each(data, function (i, v) {

            var row = "<tr onclick='lookupMemberClick(this)' style=\"white-space: nowrap; \">";
            if (i === 0) {
                row = "<div class=\"row header flex flex-direction-row\" style=\"font-weight:bold;\">"
                    + "<div style=\"width: 20%; padding-right: .6em;\">" + modal_member_no + "</div>"
                    + "<div style=\"width: 20%; padding-right: .6em;\">" + modal_fullname + "</div>"
                    + "<div style=\"width: 20%; padding-right: .6em;\">" + modal_email + "</div>"
                    + "<div style=\"width: 20%; padding-right: .6em;\">" + modal_phone + "</div>"
                    + "<div style=\"width: 20%; padding-right: .6em;\">" + modal_hcp + "</div>"
                    + "</div>";
                $result.append(row);
                $result.append("<div id=\"local-members\" class=\"local-members\"></div>");
                $result.append("<div id=\"external-members\" class=\"external-members\"></div>");
                $('#local-members').append("<div class=\"row subheader flex flex-direction-row\" style=\"font-weight:bold;\">" + model_localMembers + "</div>");
                $('#external-members').append("<div class=\"row subheader flex flex-direction-row\" style=\"font-weight:bold;\">" + model_externalMembers + "</div>");
            }

            row = "<div class=\"flex flex-direction-row\" style=\"width: 100%; \">"
                + "<div class=\"label-modal-item\">" + (v.memberNumber || "---") + "</div>"
                + "<div class=\"label-modal-item\">" + (v.fullName || "---") + "</div>"
                + "<div class=\"label-modal-item\">" + (v.primaryEmail || "---") + "</div>"
                + "<div class=\"label-modal-item\">" + (v.primaryMobile || "---") + "</div>"
                + "<div class=\"label-modal-item\">" + (v.hcp || "---") + "</div>"
                + "</div>";

            if (row.length === 0)
                return;

            memberLookupModalID_test = memberLookupModalID;
            var $item = $('<a class=\"row \" style=\"width: 100%;padding: none;\"  href="javascript:void(0)">' + row + '</a>');
            $item.data('lookup', v);
            if (v.isLocal) {
                $('#my_customers_accord').append($item);
            } else {
                $('#other_players_accord').append($item);
            }
        });
        $('#my_customers_accord_header').find('.accordion-header-text').text(modal_my_customers_accord_header + " (" + $('#my_customers_accord').children().length + " " + modal_results + ")");
        if ($('#my_customers_accord').children().length === 1 && $('#my_customers_accord').children().get(0).id === "empty") {
            $('#my_customers_accord_header').find('.accordion-header-text').text(modal_my_customers_accord_header + " (0 " + modal_results + ")");
        }
        $('#other_players_accord_header').find('.accordion-header-text').text(modal_ohter_players_accord_header + " (" + $('#other_players_accord').children().length + " " + modal_results + ")");
        if ($('#my_customers_accord').children().length > 0) {
            $('#other_players_accord_header')
                .removeClass('active')
                .find('.accordion-body');
            $('#my_customers_accord_header')
                .addClass('active')
                .find('.accordion-body');
        } else if ($('#my_customers_accord').children().length === 0 && $('#other_players_accord').children().length > 0) {
            $('#my_customers_accord').add("<div id=\"empty\" class=\"flex flex-center\" style=\"flex-grow:1; height:30px; font-style:italic;\">" + modal_no_results + "<div>");
            $('#my_customers_accord_header')
                .removeClass('active')
                .find('.accordion-body');
            $('#other_players_accord_header')
                .addClass('active')
                .find('.accordion-body');
        } else if ($('#my_customers_accord').children().length === 0 && $('#other_players_accord').children().length === 0) {
            $('#my_customers_accord').add("<div id=\"empty\" class=\"flex flex-center\" style=\"flex-grow:1; height:30px; font-style:italic;\">" + modal_no_results + "<div>");
            $('#other_players_accord_header')
                .removeClass('active')
                .find('.accordion-body');
            $('#my_customers_accord_header')
                .addClass('active')
                .find('.accordion-body');
        }
    }).fail(function () {
        $('#my_customers_accord').empty().html('<div id=\"empty\" class=\"flex flex-center\" style=\"flex-grow:1; height:30px; font-style:italic;\">' + model_noMembersFound + '</div>');
        $('#other_players_accord').empty();
        $('#my_customers_accord_header').find('.accordion-header-text').text(modal_my_customers_accord_header + " (" + $('#my_customers_accord').children().length + " " + modal_results + ")");
        if ($('#my_customers_accord').children().length === 1 && $('#my_customers_accord').children().get(0).id === "empty") {
            $('#my_customers_accord_header').find('.accordion-header-text').text(modal_my_customers_accord_header + " (0 " + modal_results + ")");
        }
        $('#other_players_accord_header').find('.accordion-header-text').text(modal_ohter_players_accord_header + " (" + $('#other_players_accord').children().length + " " + modal_results + ")");
    });
}

var memberLookupModalID_test;

function updateCurrentrow(participant) {
    var indexindex = updateRow;
    $('[name=\'Participants[' + indexindex + '].ExternalId\']').val(participant.externalId !== "" ? participant.externalId : "");
    $('[name=\'Participants[' + indexindex + '].PlayerGuid\']').val(participant.playerGuid || "00000000-0000-0000-0000-000000000000");
    $('[name=\'Participants[' + indexindex + '].OrderGUID\']').val(participant.orderGUID || "00000000-0000-0000-0000-000000000000");
    $('[name=\'Participants[' + indexindex + '].MemberId\']').val(participant.memberNumber || "");
    $('[name=\'Participants[' + indexindex + '].fullName\']').val(participant.fullName || null);
    $('[name=\'Participants[' + indexindex + '].Email\']').val(participant.primaryEmail || "");
    $('[name=\'Participants[' + indexindex + '].Phone\']').val(participant.primaryMobile || "");
    $('#' + indexindex + 'MemberId').text(participant.memberNumber || "---");
    $('#' + indexindex + 'fullName').text(participant.fullName || "---");
    $('#' + indexindex + 'Email').text(participant.primaryEmail || "---");
    $('#' + indexindex + 'Phone').text(participant.primaryMobile || "---");
}

function addrow(participant) {
    var count = $('.responsive-helper-participants > .row').length;
    $('.responsive-helper-participants > .row:nth-child(' + count + ')').after(
        "<div data-index=" + (count - 1) + " class=\"participants-row participants-locked flex flex-direction-column row \">"
        + "<div class=\"listitem-content-container flex flex-start-horizontal\">"
        + "<div class=\"hidden_area\">"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].ExternalId\" value = '" + (participant.externalId || "") + "' />"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].PlayerGuid\" value = '" + (participant.playerGuid || "00000000-0000-0000-0000-000000000000") + "' />"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].OrderGUID\" value = '" + (participant.orderGUID || "00000000-0000-0000-0000-000000000000") + "' />"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].MemberId\" value='" + (participant.memberNumber || "") + "'></input>"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].fullName\" value='" + (participant.fullName || null) + "'></input>"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].Email\" value='" + (participant.primaryEmail || "") + "'></input>"
        + "<input type=\"hidden\" name=\"Participants[" + (count - 1) + "].Phone\" value='" + (participant.primaryMobile || "") + "'></input>"
        + " </div>"
        + "<div class=\"responsive-helper-participant-item  flex flex-start-horizontal flex flex-direction-row\" >"
        + "<label id=\"" + (count - 1) + "memberId\" class=\"label\" >" + (participant.memberNumber || "---") + "</label>"
        + "<label id=\"" + (count - 1) + "fullName\" class=\"label\">" + (participant.fullName || "---") + "</label>"
        + "<label id=\"" + (count - 1) + "primaryEmail\" class=\"label\">" + (participant.primaryEmail || "---") + "</label>"
        + "<label id=\"" + (count - 1) + "primaryPhone\" class=\"label\">" + (participant.primaryMobile || "---") + "</label>"
        + "<label  class=\"label\">" + (participant.hcp || "---") + "</label>"
        + "</div >"
        + "</div >"
        + "<div class= \"listitem-button-container flex flex-end-horizontal flex-center-vertical \" >"
        + (renderInvoice ? "<span><label>" + model_invoice + "</label><input type = \"checkbox\" onclick=\"$(this).val($(this).prop('checked'));\" value=\"" + participant.sendInvoice + "\" name=\"Participants[" + (count - 1) + "].SendInvoice\"   " + (participant.sendInvoice ? "checked=(participant.sendInvoice)" : "") + " value=" + participant.sendInvoice + " /></span>" : "")
        + "<div class=\"input-wrapper\">"
        + (renderInvoice ? "<input name=\"Participants[" + (count - 1) + "].Discount\" type =\"number\" min=\"0\" placeholder = " + model_discound + " style =\"width: 90px;\" />" : "")
        + "</div >"
        + button_trashcan
        + "</div >"
        + " </div>");

    var form = $('.responsive-helper-participants > .row:nth-child(' + count + ')').closest('form');
    if (Participants.rules.minRequired && count < Participants.min) {
        form.find('.save-button').attr('disabled', true).prop('disabled', true);
    } else {
        form.trigger('validate');
    }

    if (Participants.max <= count) {
        $('.participants div').last().addClass('hidden');
    }
}

function lookupMemberClick() {
    var $target = $(this);

    $target.attr('data-active', '1');
    $target.siblings().attr('data-active', '0');

    Clear.input('.participant-lookup-container');

    var data = $target.data().lookup;

    addrow(data);
    opdateParticitantsCount();
    lookupClose(memberLookupModalID_test);
}